import { IonButton, IonIcon } from "@ionic/react";
import React from "react";
import BrowserService from "../helpers/BrowserService";
import { book } from "ionicons/icons";
import moment from 'moment-timezone';
import { isSupportedCountry, supportedTimezones } from "../db/Data";

type Props = {
  name: string;
};
export const ButtonGuide: React.FC<Props> = (props) => {
  return (
    <>
      {isSupportedCountry && (
        <div className="ion-text-right ion-padding">
          <IonButton onClick={() => BrowserService.showGuide(props.name)} size="small" fill="outline">
            <IonIcon icon={book} slot="start" /> User Guide
          </IonButton>
        </div>
      )}
    </>
  );
};
